import React, { useState, useEffect } from "react";
import { Steps, Row, Skeleton, Tooltip } from "antd";
import { withTranslation } from "react-i18next";

const StepTelemetry = ({ telemetryTypeCode, temp, humidity }) => {
  if (!temp) return null;

  const showHumidity = telemetryTypeCode === 4;
  const showTemp = telemetryTypeCode === 4 || telemetryTypeCode === 5;

  if (!showTemp) return null;

  return (
    <div className="step-telemetry">
      <span>Temperatura: {temp}</span>
      {showHumidity && <span>Humedad: {humidity}</span>}
    </div>
  );
};

const StepDescription = ({
  description,
  telemetryTypeCode,
  temp,
  humidity,
}) => {
  if (!description) return null;

  return (
    <div className="step-description">
      <div>{description}</div>
      <StepTelemetry
        telemetryTypeCode={telemetryTypeCode}
        temp={temp}
        humidity={humidity}
      />
    </div>
  );
};

const REDIRECTION_URL =
  "https://www.correos.es/es/es/herramientas/localizador/envios/detalle?tracking-number=";

const INITIAL_STATE = {
  current: 0,
  redirect: false,
  message: "Cargando...",
  status: "loading",
  statusCode: 0,
  steps: [],
  shipmentType: "online",
  telemetryTypeCode: null,
};

function EventBar({ shipmentCode, eventsInfo, stepsRef }) {
  const [eventBarParameters, setEventBarParameters] = useState({
    ...INITIAL_STATE,
    track_num: shipmentCode,
  });

  const { Step } = Steps;

  useEffect(() => {
    if (eventsInfo.statusCode === 0) {
      setEventBarParameters((prev) => ({
        ...prev,
        status: "loading",
        statusCode: 0,
        message: "Cargando...",
      }));
      return;
    }

    if (eventsInfo.statusCode !== 200) {
      setEventBarParameters((prev) => ({
        ...prev,
        status: "loaded",
        statusCode: eventsInfo.statusCode,
        message: eventsInfo.message,
      }));
      return;
    }

    setEventBarParameters((prev) => ({
      ...prev,
      statusCode: eventsInfo.statusCode,
      steps: eventsInfo.steps,
      current: eventsInfo.current,
      status: "loaded",
      message: eventsInfo.message,
      shipmentType: eventsInfo.shipmentType || "online",
      telemetryTypeCode: eventsInfo.telemetryTypeCode ?? null,
    }));
  }, [eventsInfo]);

  const { status, statusCode, track_num, current, steps, telemetryTypeCode } =
    eventBarParameters;

  return (
    <div className="Pasos">
      <Row>
        <h2>
          Situación actual del envío: <strong>{track_num}</strong>
        </h2>

        {status === "loading" && <Skeleton active />}

        {status === "loaded" && statusCode === 200 && (
          <>
            <div ref={stepsRef}>
              <Steps current={current}>
                {steps.map((item) => (
                  <Step
                    key={item.title}
                    title={
                      <Tooltip title={item.location}>
                        <span>{item.title}</span>
                      </Tooltip>
                    }
                    description={
                      <StepDescription
                        description={item.description}
                        telemetryTypeCode={telemetryTypeCode}
                        temp={item.temp}
                        humidity={item.humidity}
                      />
                    }
                  />
                ))}
              </Steps>
            </div>
            <div className="moreInfo">
              <a
                href={`${REDIRECTION_URL}${track_num}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>Mas información</span>{" "}
                <svg
                  viewBox="64 64 896 896"
                  focusable="false"
                  data-icon="right"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"></path>
                </svg>
              </a>
            </div>
          </>
        )}
      </Row>
    </div>
  );
}

export default withTranslation()(EventBar);
